import {init, use} from 'echarts/core'
import {BarChart, PieChart} from 'echarts/charts'
import {CanvasRenderer} from 'echarts/renderers'
import {GridComponent, LegendComponent, TitleComponent, TooltipComponent} from 'echarts/components'

use([
  BarChart,
  PieChart,
  CanvasRenderer,
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
])

export {init}
